import { BuiltinAtoms } from '@lemon8/web-app-shared/atom';
import {
  $DiscoverData,
  $DiscoverBreadcrumbs,
  $ArticleComments,
  $ArticleDetail,
  $ArticleRelatedPost,
  $ArticleRelatedHashtag,
  $ArticleRelatedExperience,
  $ArticleGPTInfo,
  $PageLevelTraffic,
  $FeedData,
  $UserDetail,
  $UserDetailV2,
  $UserPost,
  $UserRelatedUser,
  $UserFollower,
  $UserFollowing,
  $UserFollowingTopic,
  $HashtagInfo,
  $HashtagPopularPost,
  $HashtagRecentPost,
  $HashtagRelated,
  $ArticleCategoryPost,
  $DiscoverClassifyHotWords,
  $ArticleGuessCardsWords,
  $PoiInfo,
  $PoiPost,
  $PoiRelated,
  $BrandBanner,
  $ArticleRelatedPostWithImmersiveData,
  $ExperienceRelatedPost,
  $ExperienceGPTAnswer,
} from 'shared/atoms';
import { $CampaignBanner } from 'shared/atoms/common/campaign-banner';
import { $CategoryList } from 'shared/atoms/common/category';
import { $UserInfo, $UserExtra } from './user';
import { $IsNewArch } from './is-new-arch';
import { $CategoryData } from './feed';

export const Atoms = {
  ...BuiltinAtoms,
  $CampaignBanner,
  $DiscoverData,
  $DiscoverBreadcrumbs,
  $DiscoverClassifyHotWords,
  $ExperienceGPTAnswer,
  $ExperienceRelatedPost,
  $UserInfo,
  $UserExtra,
  $UserPost,
  $UserDetailV2,
  $UserRelatedUser,
  $CategoryList,
  $IsNewArch,
  $UserFollower,
  $UserFollowing,
  $UserFollowingTopic,
  $HashtagInfo,
  $HashtagPopularPost,
  $HashtagRecentPost,
  $HashtagRelated,
  $PoiInfo,
  $PoiPost,
  $PoiRelated,
  $FeedData,
  $CategoryData,
  $ArticleComments,
  $ArticleDetail,
  $PageLevelTraffic,
  $ArticleRelatedPost,
  $ArticleRelatedExperience,
  $ArticleRelatedPostWithImmersiveData,
  $ArticleCategoryPost,
  $ArticleRelatedHashtag,
  $ArticleGuessCardsWords,
  $UserDetail,
} as const;

export const HydrationAtomsMap = {
  $CampaignBanner,
  $CategoryList,
  $IsNewArch,
  $CategoryData,
  $PageLevelTraffic,
  $BrandBanner,
} as const;

export const HydrationAtomFamiliesMap = {
  $DiscoverData,
  $DiscoverBreadcrumbs,
  $DiscoverClassifyHotWords,
  $ExperienceGPTAnswer,
  $ExperienceRelatedPost,
  $UserInfo,
  $UserExtra,
  $UserFollower,
  $UserFollowing,
  $UserFollowingTopic,
  $HashtagInfo,
  $HashtagPopularPost,
  $HashtagRecentPost,
  $HashtagRelated,
  $PoiInfo,
  $PoiPost,
  $PoiRelated,
  $FeedData,
  $ArticleComments,
  $ArticleDetail,
  $ArticleRelatedPost,
  $ArticleRelatedExperience,
  $ArticleRelatedPostWithImmersiveData,
  $ArticleCategoryPost,
  $ArticleRelatedHashtag,
  $ArticleGuessCardsWords,
  $ArticleGPTInfo,
  $UserDetail,
  $UserPost,
  $UserDetailV2,
  $UserRelatedUser,
} as const;
